import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 15l-3 -3l3 -3","key":"svg-0"}],["path",{"d":"M21 12a9 9 0 1 0 -18 0a9 9 0 0 0 18 0z","key":"svg-1"}]]

const IconCircleChevronLeft = createReactComponent('outline', 'circle-chevron-left', 'CircleChevronLeft', __iconNode);

export default IconCircleChevronLeft;